import React from 'react';

const Footer: React.FC = () => (
  <footer className="footer">
    © 2025 Andrew Sorensen. All rights reserved.
  </footer>
);

export default Footer;